module.exports = __webpack_public_path__ + "img/bluetooth-speaker.f419f8bf.svg";